/* MoTH Promo Bar — date-gated countdown for the reusable monthly promo bar.
   Renders nothing unless within the configured window (fail-safe: stays hidden
   if this script fails to load, because the bar's inline style is display:none).
   QA preview: ?mpb_preview=live or ?mpb_preview=teaser force-renders the bar. */
(function () {
  var bar = document.querySelector('[data-moth-promo]');
  if (!bar) return;

  var root = document.documentElement;
  var teaserStart = Date.parse(bar.getAttribute('data-teaser-start'));
  var start = Date.parse(bar.getAttribute('data-start'));
  var end = Date.parse(bar.getAttribute('data-end'));
  var showTeaser = bar.getAttribute('data-show-teaser') === 'true';
  var prefersReduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

  // Auto-activate the full sale theme (product badges + Variant-2 sale hero) during
  // the sale window — same dates as the bar. Reverts on its own once the window ends.
  if (Date.now() >= start && Date.now() < end) {
    root.classList.add('mpb-badges-on', 'mpb-hero2-on');
  }

  // QA preview overrides (invisible to customers): force the states for review.
  var pv = null;
  try {
    var qp = new URLSearchParams(window.location.search);
    pv = qp.get('mpb_preview');
    if (pv === 'live' || pv === 'teaser') root.classList.add('mpb-badges-on', 'mpb-hero2-on'); // approved combo
    if (qp.get('mpb_badge') === '1') root.classList.add('mpb-badges-on');
    if (qp.get('hero2') === '1') root.classList.add('mpb-hero2-on');
  } catch (e) {}

  // The sale hero: replace the PageFly hero — drop ours in its place and hide the
  // original (avoids z-index/content bleed).
  if (root.classList.contains('mpb-hero2-on')) {
    var h2 = document.querySelector('.pf-12_');
    var ov = document.getElementById('moth-hero2');
    if (h2 && ov && h2.parentNode) {
      h2.parentNode.insertBefore(ov, h2);
      h2.style.display = 'none';
      ov.hidden = false;
    }
  }

  var liveEl = bar.querySelector('[data-promo-live]');
  var teaserEl = bar.querySelector('[data-promo-teaser]');
  var labelEl = bar.querySelector('[data-promo-countlabel]');
  var ctaEl = bar.querySelector('[data-promo-cta]');
  var dEl = bar.querySelector('[data-d]');
  var hEl = bar.querySelector('[data-h]');
  var mEl = bar.querySelector('[data-m]');
  var sEl = bar.querySelector('[data-s]');
  var timer;


  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Update a digit; flip the card only when the value actually changes.
  function setDigit(el, val) {
    if (!el || el.textContent === val) return;
    if (prefersReduced) { el.textContent = val; return; }
    var card = el.parentNode;
    card.classList.remove('is-flipping');
    void card.offsetWidth;                              // reflow so the animation restarts
    card.classList.add('is-flipping');
    setTimeout(function () { el.textContent = val; }, 175); // swap near the fold midpoint
  }

  // Publish the bar's rendered height so the theme's sticky header can offset
  // beneath it (CSS: .header-sticky.is-sticky{top:var(--mpb-h)}). 0 when hidden.
  function setBarH() {
    var h = (document.body.contains(bar) && bar.style.display !== 'none') ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--mpb-h', h + 'px');
  }

  function paint(mode, target) {
    bar.style.display = 'block';
    var teaser = mode === 'teaser';
    teaserEl.hidden = !teaser;
    liveEl.hidden = teaser;
    if (labelEl) labelEl.textContent = teaser ? 'STARTS IN' : 'ENDS IN';
    if (ctaEl) ctaEl.style.display = teaser ? 'none' : '';

    var diff = Math.max(0, target - Date.now());
    var sec = Math.floor(diff / 1000);
    var d = Math.floor(sec / 86400); sec -= d * 86400;
    var h = Math.floor(sec / 3600); sec -= h * 3600;
    var m = Math.floor(sec / 60); sec -= m * 60;
    setDigit(dEl, pad(d));
    setDigit(hEl, pad(h));
    setDigit(mEl, pad(m));
    setDigit(sEl, pad(sec));
    setBarH();
  }

  function tick() {
    if (pv === 'live' || pv === 'teaser') {       // QA override — invisible to customers
      paint(pv, Date.now() + 3 * 86400000);
      return;
    }
    var now = Date.now();
    if (now >= end) {                             // sale over → remove the bar
      if (bar.parentNode) bar.parentNode.removeChild(bar);
      setBarH();
      clearInterval(timer);
      return;
    }
    if (now < start) {                            // before sale
      if (!showTeaser || now < teaserStart) { bar.style.display = 'none'; setBarH(); return; }
      paint('teaser', start);
      return;
    }
    paint('live', end);                           // sale live
  }

  tick();
  timer = setInterval(tick, 1000);
  window.addEventListener('resize', setBarH);     // keep header offset correct on resize
})();
